import * as React from "react";
import LoginPage from "./LoginPage";

export function AuthPage() {
  return (
    <>
      <LoginPage />
    </>
  );
}
